<!--
@Author: Calvin Green <calvin>
@Date:   2021-11-18T07:04:05+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-16T14:09:27+02:00
@Copyright: Diversitude 2022
-->



<template>
    <b-overlay :show="clicked_row">
            <b-card>
                <webix-ui :config="config" v-model="activity_steps"></webix-ui>
            </b-card>
    </b-overlay>
</template>

<script>
import { format, parseISO, isBefore } from 'date-fns';
import _ from 'lodash';
import { licenseAppState, licenseAppMethods } from '@/state/helpers'
export default {
    data:() => ({
        clicked_row: false,
        config:{
            scheme:{
                $change:function(item){
                    if (item.status === 'complete')
                        item.$css = "complete-css";
                    else if (item.status === 'pending_client_review')
                        item.$css = "pending-css";
                }
            },
            hover: 'webix-row-hover',
            id: 'clientStepsTable',
            view: 'datatable',
            css: "datatableUsers webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'index', header:'', fillspace: 0.1},
                { id: 'id', header:'', hidden: true},
                { id: 'status', header:'', fillspace: 0.1, template: function(object){
                    if(object.status == 'complete'){
                        return '<span title="Complete" class="webix_icon_hover webix_icon complete_icon fas fa-check"/>';
                    }
                    else if(object.status == 'in_progress'){
                        return '<span title="In Progress" class="webix_icon_hover webix_icon busy_icon fas fa-question"/>'
                    }
                    else if(object.status == 'pending_validation'){
                        return '<span title="Waiting For Validation" class="webix_icon_hover webix_icon pending_icon fas fa-user-clock"/>'
                    }
                    else if(object.status == 'pending_client_review'){
                        return '<span title="Waiting For Client Review" class="webix_icon_hover webix_icon pending_icon fas fa-exclamation-triangle    "/>'
                    }
                    else if(object.status == 'pending_revalidation'){
                        return '<span title="Waiting For Admin Validation" class="webix_icon_hover webix_icon pending_icon fas fa-exclamation-triangle    "/>'
                    }
                    else{
                        return '';
                    }
                }},
                { id: 'name', header:'Activity', fillspace: true},
                /*{ id: 'due_date', header:'Due Date', fillspace: 0.4, template:function(object){
                    if(object.is_overdue){
                        return `<span style="color: red;">${object.due_date}</span>`
                    }
                    else{
                        return `<span style="color: green;">${object.due_date}</span>`
                    }
                }},*/
                { id: 'liason_contact', header:'Liason Contact', fillspace: 0.5},
                { id: 'ccb_contact', header:'CCB Contact', fillspace: 0.5},
                { id: 'actions', header:'', fillspace: 0.2,  template: function(object){
                    let comment = '';
                    if(object.comments){
                        comment = '<i title="View comment" class="webix_icon_hover webix_icon timeline_comment comment_true fas fa-comment"></i>'
                    }
                    else{
                        comment = '<i title="No Comment" class="webix_icon_hover webix_icon timeline_comment comment_false far fa-comment"></i>'
                    }

                    let action = '';
                    if(object.action_required){
                        action = '<i title="Go to action" class="webix_icon_hover webix_icon timeline_action action_true far fa-question-circle"></i>'
                    }
                    else{
                        action = '<i title="No action" class="webix_icon_hover webix_icon timeline_action action_false far fa-question-circle"></i>'
                    }

                    return `<div style="text-align: center;">${comment} &nbsp; ${action}</div>`
                }}
            ],
            on:{//eslint-disable-next-line
                onItemClick(id, e, node){
                    let el = this.$scope.$parent.$parent;

                    setTimeout(()=>{
                        if(el.clickedAction === false){
                            el.clicked_row = true;
                            el.selectRow(id.row);
                        }
                    }, 50)

                }
            },
            onClick:{
                //eslint-disable-next-line
                timeline_action(event, cell, target){
                    let el = this.$scope.$parent.$parent;
                    el.clickedAction = true;
                    setTimeout(()=> {el.clickedAction = false;} , 500)
                    console.log('Action');
                },
                //eslint-disable-next-line
                timeline_comment(event, cell, target){
                    let el = this.$scope.$parent.$parent;
                    el.clickedAction = true;
                    setTimeout(()=> {el.clickedAction = false;} , 500)
                    console.log('Comment');
                }
            }
        },

        //used to check if user clicked row or action button
        clickedAction: false,
    }),
    computed:{
        ...licenseAppState,
        activity_steps(){
            if(this.app_data != null){
                let steps = _.cloneDeep(this.app_data.steps);
                steps.forEach((step, index) => {
                    step.index = index + 1;
                    step.is_overdue = isBefore(parseISO(step.due_date), new Date());
                    step.due_date = format(parseISO(step.due_date), 'dd MMM yyyy');
                })
                //this.app_data.steps.map( step => format(parseISO(step.due_date), 'dd MMM yyyy'))
                //return this.app_data.steps;
                return steps;
            }
            else{
                return [];
            }
        }
    },
    methods:{
        ...licenseAppMethods,
        //eslint-disable-next-line
        selectRow(id){
            this.loadStepData(id)
            .then(()=>{
                this.$emit('selectedRow', id);
            })
            .catch(()=>{
                console.log('err')
            })
        }
    },
    mounted(){

    },
}
</script>

<style>
.complete_icon{
    color: rgb(21, 192, 21);
}
.busy_icon{
    color: dodgerblue;
}
.pending_icon{
    color: #f1734f;
}
.action_true{
    color: red;
}
.comment_true{
    color: dodgerblue;
}
.complete-css{
    background-color: rgb(184, 231, 184);
}
.pending-css{
    background-color: rgb(253, 242, 141);
}
</style>
